import { ConfigService } from '@services/config-service';
import { Component, EventEmitter, h, Host, Prop, Event as StencilEvent } from '@stencil/core';
import { formatNumberIN } from '@utils/utilities';

@Component({
  tag: 'unification-card',
  styleUrl: 'unification-card.scss',
  shadow: true
})
export class UnificationCard {
  @Prop() card: any;
  @StencilEvent() selectCard: EventEmitter<{ value: any }>;
  cardFaciaUrl: string = ConfigService.cardFaciaCdnUrl || '';
  private onCardSelect = () => {
    this.selectCard.emit(this.card);
  };

  onCardFaciaError = (event: any) => {
    if (event.target.dataset.fallback) return; // already tried fallback
    event.target.onerror = null;
    event.target.src = `${this.cardFaciaUrl}default.webp`;
    event.target.dataset.fallback = 'true';
  };

  render() {
    return (
      <Host>
        <div onClick={this.onCardSelect} class="flex border-b border-gray-700 cursor-pointer border-solid items-center gap-4 py-6  md:p-4">
          <div>
            <img onError={this.onCardFaciaError} height={40} width={50} alt="" src={this.cardFaciaUrl + this.card.imageUrl} />
          </div>
          <div class="flex flex-1 md:flex-col justify-between">
            <div class="flex items-center gap-2 spac">
              <span class="text-sm max-w-[120px] truncate">{this.card?.subProgram?.replaceAll("_", " ") || this.card?.alter_name?.replaceAll("_", " ")}</span>
              <span class="text-[10px] text-gray-500 tracking-widest"> **** {this.card?.last4digit}</span>
            </div>
            {this.card.pointsLoading ? (
              <div class="font-bold text-sm flex gap-1 items-center">
                <skeleton-element class="w-10 h-4 rounded-md" />
                Pts
              </div>
            ) : (
              <span class="font-bold text-sm">{formatNumberIN(this.card?.redeemablePoints)} Pts</span>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
